module.exports = __webpack_public_path__ + "media/机器人实操基地13.5b835b88.mp4";